export const size = {
  mobile: '768px',
  laptop: '1080px'
}

export const device = {
  mobile: `(max-width: ${size.mobile})`,
  laptop: `(max-width: ${size.laptop})`
}
